var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Watch } from 'vue-property-decorator';
import { TargetGroup } from '@/common/types/TargetGroup';
import InvestmentBudgetaryEstimateBase from '@/template/components/aidApplication/investment/InvestmentBudgetaryEstimateBase';
import AttachmentRow from '@/common/components/AttachmentRow.vue';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import EstimatesAndDetailsControl from '@/template/components/aidApplication/budgetaryEstimate/EstimatesAndDetailsControl.vue';
import ApartmentProcurementControl from '@/template/components/aidApplication/investment/ApartmentProcurementControl.vue';
import ApartmentSummaryControl from '@/template/components/aidApplication/investment/ApartmentSummaryControl.vue';
import _ from "lodash";
var SupportApartmentsBudgetaryEstimateView = /** @class */ (function (_super) {
    __extends(SupportApartmentsBudgetaryEstimateView, _super);
    function SupportApartmentsBudgetaryEstimateView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SupportApartmentsBudgetaryEstimateView.prototype, "model", {
        get: function () {
            return this.item.supportApartments;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SupportApartmentsBudgetaryEstimateView.prototype, "showDescription", {
        get: function () {
            return this.model.apartments.some(function (x) { return x.targetGroup === TargetGroup.Other; });
        },
        enumerable: false,
        configurable: true
    });
    SupportApartmentsBudgetaryEstimateView.prototype.updateApartmentSummary = function () {
        var _this = this;
        var summaryItems = [];
        var groupedByMunicipality = _.groupBy(this.model.apartments.filter(function (x) { return _this.isValid(x); }), function (appartment) { return appartment.municipality.name; });
        _.forEach(groupedByMunicipality, function (group) { return summaryItems.push(_this.addSummaryItem(group)); });
        this.model.apartmentSummary = summaryItems;
        if (!this.showDescription)
            this.model.apartmentDescription = null;
    };
    SupportApartmentsBudgetaryEstimateView.prototype.isValid = function (item) {
        return item.municipality && item.municipality.name
            && item.avgSize != null
            && item.totalCosts != null;
    };
    SupportApartmentsBudgetaryEstimateView.prototype.addSummaryItem = function (items) {
        var totalCount = _.sumBy(items, function (item) { return item.count; });
        var totalCosts = _.sumBy(items, function (item) { return item.totalCosts; });
        var totalAvgCosts = totalCount && totalCosts ? Math.round(Number(totalCosts) / Number(totalCount)) : null;
        return {
            targetGroup: TargetGroup.None, municipality: items[0].municipality, count: totalCount, avgPrice: totalAvgCosts
        };
    };
    __decorate([
        Watch("model.apartments", { deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SupportApartmentsBudgetaryEstimateView.prototype, "updateApartmentSummary", null);
    SupportApartmentsBudgetaryEstimateView = __decorate([
        Component({
            name: 'SupportApartmentsBudgetaryEstimateView',
            components: {
                AttachmentRow: AttachmentRow,
                TextAreaRow: TextAreaRow,
                EstimatesAndDetailsControl: EstimatesAndDetailsControl,
                ApartmentProcurementControl: ApartmentProcurementControl,
                ApartmentSummaryControl: ApartmentSummaryControl
            }
        })
    ], SupportApartmentsBudgetaryEstimateView);
    return SupportApartmentsBudgetaryEstimateView;
}(InvestmentBudgetaryEstimateBase));
export default SupportApartmentsBudgetaryEstimateView;
